import {PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepConfig} from 'pipelines/PipelineTypes';
import {RenameAndReplaceKey} from 'util/Types';

export type AnalysisDataLayout = RenameAndReplaceKey<
  PipelineStepConfig<PipelineStepType.LAYOUT, 0>,
  'configPath',
  'configPath',
  Array<string | number> // Backend doesn't support defining union[string, number] in the manifest although this is the expected type.
>;

export type AnalysisGrid = Extract<AnalysisDataLayout['sections'][number], {type: 'GRID'}>['grid'];
export type AnalysisConfigForm = Extract<AnalysisGrid['rows'][number][number], {type: 'CONFIG_FORM'}>;
export type AnalysisDataView = Extract<AnalysisGrid['rows'][number][number], {type: 'DATA_VIEW'}>;
export type AnalysisMarkdown = Extract<AnalysisGrid['rows'][number][number], {type: 'MARKDOWN'}>;
export type AnalysisNestedGrid = Extract<AnalysisGrid['rows'][number][number], {type: 'NESTED_GRID'}>;
export type AnalysisGridBlock = AnalysisConfigForm | AnalysisDataView | AnalysisMarkdown | AnalysisNestedGrid;
export type AnalysisConfigFormField = AnalysisConfigForm['configFields'][number];
export type AnalysisConfigReference = AnalysisConfigFormField['configReferences'][number];
export type AnalysisStatusReference = NonNullable<
  AnalysisDataLayout['statusDependencies']
>[number]['statusReferences'][number];

export enum AnalysisLayoutStatus {
  RUNNING = 'RUNNING',
  FAILED = 'FAILED',
  READY = 'READY',
}
export type AnalysisLayoutStatusInfo =
  | {status: AnalysisLayoutStatus.READY}
  | {status: AnalysisLayoutStatus.RUNNING; message: string}
  | {status: AnalysisLayoutStatus.FAILED; message: string; reason: string};
